import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";

import About from "./pages/About";
import MyDashboard from "./pages/MyDashboard";
import Career from "./pages/Career";
import Features from "./pages/Features";
import Contact from "./pages/Contact";
import PricingPlan from "./pages/PricingPlan";
import Clients from "./pages/Client";
import Gallery from "./pages/Gallery";
import Privacy from "./pages/Privacy";
import SecurityPolicy from "./pages/SecurityPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ProspectingSearch from "./pages/ProspectingSearch";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgetPassword from "./pages/ForgetPassword";
import CompanySearch from "./pages/CompanySearch";
import ExecutiveSearch from "./pages/ExecutiveSearch";
import LeadSearch from "./pages/LeadSearch";
import ExecutiveDetails from "./pages/ExecutiveDetails";
import ProductComparison from "./pages/ProductComparison";
import ProductComparisionNew from "./pages/ProductComparisonNew";
import CompanySummary from "./pages/CompanySummary";
import UserAccountInfo from "./pages/UserAccountInfo";
import OurData from "./pages/OurData";
import DirectDials from "./pages/DirectDials";
import LeadsManagement from "./pages/LeadsManagement";
import Integrations from "./pages/Integrations";
import B2BData from "./pages/B2BData";
import Faq from "./pages/Faq";
import Leads from "./pages/Leads";
import LeadDetails from "./pages/LeadDetails";
import LeadKanban from "./pages/LeadKanban";
import MoreMenuContent from "./pages/MoreMenuContent";
import LeadsTimeline from "./pages/LeadsTimeline";
import CheckToken from "./common/checkToken";
import ResetPassword from "./pages/ResetPassword";
import Sales from "./pages/Sales";
import Marketing from "./pages/Marketing";
import Hiring from "./pages/Hiring";
import Extension from "./pages/Extension";
import ListBuilding from "./pages/List";
import DataEnrich from "./pages/DataEnrich";
import Linkedin from "./pages/Linkedin";
import Hospitality from "./pages/Hospitality";
import KeyFeatures from "./pages/KeyFeatures";
import Finance from "./pages/Finance";
import Technology from "./pages/Technology";
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertProvider";
import Review from "./pages/Review";
import Channel from "./pages/Channel";
import Web2Lead from "./pages/Web2Lead";
import CreateLeadForm from "./pages/CreateLeadForm";
import Seo from "./pages/Seo";
import Demo from "./pages/Demo";
import WhatWeOffer from "./pages/whatWeOffer";
import Meta from "./pages/Meta";
import AdminContainer from "./components/settings/AdminContainer";
import EmailSetup from "./pages/EmailSetup";
import AuthCallback from "./pages/AuthCallback";
import { EmailProvider } from "./context/EmailContext";
import metaInfo from "./components/meta/metaInfo";
import ReputationManagerContainer from "./components/reputation-manager/ReputationManagerContainer";
import Settings from "./components/reputation-manager/settings/Settings";
import Reviews from "./components/reputation-manager/review/Reviews";
import UserManagement from "./pages/UserManagement";
import ChangePassword from "./pages/ChangePassword";
import RouteGuard from "./pages/RouteGuard";

const AppRoutes = (props) => {
  return (
    <HelmetProvider>
      <Router basename="" {...props}>
        <AuthProvider>
          <EmailProvider>
            <AlertProvider>
              <RouteGuard>
                <Routes path="/" {...props}>
                  <Route
                    index
                    element={
                      <>
                        <Meta
                          title={metaInfo.home.title}
                          description={metaInfo.home.description}
                          keywords={metaInfo.home.keywords}
                        />
                        <Home />
                      </>
                    }
                  />
                  <Route
                    path="/signin"
                    element={
                      <>
                        <Meta
                          title={metaInfo.signIn.title}
                          description={metaInfo.signIn.description}
                          keywords={metaInfo.signIn.keywords}
                        />
                        <Login />
                      </>
                    }
                  />
                  <Route
                    path="/signup"
                    element={
                      <>
                        <Meta
                          title={metaInfo.signUp.title}
                          description={metaInfo.signUp.description}
                          keywords={metaInfo.signUp.keywords}
                        />
                        <Signup />
                      </>
                    }
                  />
                  <Route
                    path="/forgetpassword"
                    element={
                      <>
                        <Meta
                          title={metaInfo.forgotPassword.title}
                          description={metaInfo.forgotPassword.description}
                          keywords={metaInfo.forgotPassword.keywords}
                        />
                        <ForgetPassword />
                      </>
                    }
                  />
                  <Route
                    path="/about-us"
                    element={
                      <>
                        <Meta
                          title={metaInfo.about.title}
                          description={metaInfo.about.description}
                          keywords={metaInfo.about.keywords}
                        />
                        <About />
                      </>
                    }
                  />
                  <Route
                    path="/dashboard-view"
                    element={
                      <>
                        <Meta
                          title={metaInfo.dashboardView.title}
                          description={metaInfo.dashboardView.description}
                          keywords={metaInfo.dashboardView.keywords}
                        />
                        <CheckToken type={"dashboard"} />
                      </>
                    }
                  />
                  <Route
                    path="/career"
                    element={
                      <>
                        <Meta
                          title={metaInfo.career.title}
                          description={metaInfo.career.description}
                          keywords={metaInfo.career.keywords}
                        />
                        <Career />
                      </>
                    }
                  />
                  <Route
                    path="/features"
                    element={
                      <>
                        <Meta
                          title={metaInfo.features.title}
                          description={metaInfo.features.description}
                          keywords={metaInfo.features.keywords}
                        />
                        <Features />
                      </>
                    }
                  />
                  <Route
                    path="/contact-us"
                    element={
                      <>
                        <Meta
                          title={metaInfo.contactUs.title}
                          description={metaInfo.contactUs.description}
                          keywords={metaInfo.contactUs.keywords}
                        />
                        <Contact />
                      </>
                    }
                  />
                  <Route
                    path="/pricing"
                    element={
                      <>
                        <Meta
                          title={metaInfo.pricing.title}
                          description={metaInfo.pricing.description}
                          keywords={metaInfo.pricing.keywords}
                        />
                        <PricingPlan />
                      </>
                    }
                  />
                  <Route
                    path="/clients"
                    element={
                      <>
                        <Meta
                          title={metaInfo.clients.title}
                          description={metaInfo.clients.description}
                          keywords={metaInfo.clients.keywords}
                        />
                        <Clients />
                      </>
                    }
                  />
                  {/* <Route path="/gallery" element={<Gallery />} /> */}
                  <Route
                    path="/sales"
                    element={
                      <>
                        <Meta
                          title={metaInfo.sales.title}
                          description={metaInfo.sales.description}
                          keywords={metaInfo.sales.keywords}
                        />
                        <Sales />
                      </>
                    }
                  />
                  <Route
                    path="/review-management"
                    element={
                      <>
                        <Meta
                          title={metaInfo.reviewManagement.title}
                          description={metaInfo.reviewManagement.description}
                          keywords={metaInfo.reviewManagement.keywords}
                        />
                        <Review />
                      </>
                    }
                  />
                  <Route
                    path="/channel-manager"
                    element={
                      <>
                        <Meta
                          title={metaInfo.channelManager.title}
                          description={metaInfo.channelManager.description}
                          keywords={metaInfo.channelManager.keywords}
                        />
                        <Channel />
                      </>
                    }
                  />
                  <Route
                    path="/marketing"
                    element={
                      <>
                        <Meta
                          title={metaInfo.marketing.title}
                          description={metaInfo.marketing.description}
                          keywords={metaInfo.marketing.keywords}
                        />
                        <Marketing />
                      </>
                    }
                  />
                  <Route
                    path="/recruiting"
                    element={
                      <>
                        <Meta
                          title={metaInfo.recruiting.title}
                          description={metaInfo.recruiting.description}
                          keywords={metaInfo.recruiting.keywords}
                        />
                        <Hiring />
                      </>
                    }
                  />
                  {/* <Route path="/extension" element={
                  <>
                    <Meta title={metaInfo.extension.title} description={metaInfo.extension.description} keywords={metaInfo.extension.keywords} />
                    <Extension />
                  </>
                } /> */}
                  <Route
                    path="/lead-enrichment"
                    element={
                      <>
                        <Meta
                          title={metaInfo.dataEnrichment.title}
                          description={metaInfo.dataEnrichment.description}
                          keywords={metaInfo.dataEnrichment.keywords}
                        />
                        <DataEnrich />
                      </>
                    }
                  />
                  <Route
                    path="/data-to-lead"
                    element={
                      <>
                        <Meta
                          title={metaInfo.listBuilding.title}
                          description={metaInfo.listBuilding.description}
                          keywords={metaInfo.listBuilding.keywords}
                        />
                        <ListBuilding />
                      </>
                    }
                  />
                  <Route
                    path="/linkedin-extension"
                    element={
                      <>
                        <Meta
                          title={metaInfo.extension.title}
                          description={metaInfo.extension.description}
                          keywords={metaInfo.extension.keywords}
                        />
                        <Linkedin />
                      </>
                    }
                  />
                  <Route
                    path="/hospitality"
                    element={
                      <>
                        <Meta
                          title={metaInfo.hospitality.title}
                          description={metaInfo.hospitality.description}
                          keywords={metaInfo.hospitality.keywords}
                        />
                        <Hospitality />
                      </>
                    }
                  />
                  <Route
                    path="/data-outreach"
                    element={
                      <>
                        <Meta
                          title={metaInfo.keyFeatures.title}
                          description={metaInfo.keyFeatures.description}
                          keywords={metaInfo.keyFeatures.keywords}
                        />
                        <KeyFeatures />
                      </>
                    }
                  />
                  <Route
                    path="/finance"
                    element={
                      <>
                        <Meta
                          title={metaInfo.finance.title}
                          description={metaInfo.finance.description}
                          keywords={metaInfo.finance.keywords}
                        />
                        <Finance />
                      </>
                    }
                  />
                  <Route
                    path="/privacy-policy"
                    element={
                      <>
                        <Meta
                          title={metaInfo.privacyPolicy.title}
                          description={metaInfo.privacyPolicy.description}
                          keywords={metaInfo.privacyPolicy.keywords}
                        />
                        <Privacy />
                      </>
                    }
                  />
                  <Route
                    path="/security-policy"
                    element={
                      <>
                        <Meta
                          title={metaInfo.securityPolicy.title}
                          description={metaInfo.securityPolicy.description}
                          keywords={metaInfo.securityPolicy.keywords}
                        />
                        <SecurityPolicy />
                      </>
                    }
                  />
                  <Route
                    path="/terms-and-conditions"
                    element={
                      <>
                        <Meta
                          title={metaInfo.termsAndConditions.title}
                          description={metaInfo.termsAndConditions.description}
                          keywords={metaInfo.termsAndConditions.keywords}
                        />
                        <TermsAndConditions />
                      </>
                    }
                  />
                  <Route
                    path="/prospecting-search"
                    element={
                      <>
                        <Meta
                          title={metaInfo.prospectingSearch.title}
                          description={metaInfo.prospectingSearch.description}
                          keywords={metaInfo.prospectingSearch.keywords}
                        />
                        <ProspectingSearch />
                      </>
                    }
                  />
                  <Route
                    path="/technology"
                    element={
                      <>
                        <Meta
                          title={metaInfo.technology.title}
                          description={metaInfo.technology.description}
                          keywords={metaInfo.technology.keywords}
                        />
                        <Technology />
                      </>
                    }
                  />
                  <Route
                    path="/executive-details/:id"
                    element={<ExecutiveDetails />}
                  />
                  <Route
                    path="/executive-details/:id/:name"
                    element={
                      <>
                        <Meta />
                        <ExecutiveDetails />
                      </>
                    }
                  />
                  {/* <Route path='/product-comparison' element={<ProductComparison />} /> */}
                  <Route
                    path="/product-comparison"
                    element={
                      <>
                        <Meta
                          title={metaInfo.productComparison.title}
                          description={metaInfo.productComparison.description}
                          keywords={metaInfo.productComparison.keywords}
                        />
                        <ProductComparisionNew />
                      </>
                    }
                  />
                  <Route
                    path="/search-company"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchCompany.title}
                          description={metaInfo.searchCompany.description}
                          keywords={metaInfo.searchCompany.keywords}
                        />
                        <CompanySearch tab="1" />
                      </>
                    }
                  />
                  <Route
                    path="/search-executive"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchExecutive.title}
                          description={metaInfo.searchExecutive.description}
                          keywords={metaInfo.searchExecutive.keywords}
                        />
                        <ExecutiveSearch tab="2" />
                      </>
                    }
                  />
                  <Route
                    path="/search-lead"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchLead.title}
                          description={metaInfo.searchLead.description}
                          keywords={metaInfo.searchLead.keywords}
                        />
                        <CheckToken type={"lead"} />
                      </>
                    }
                  />
                  <Route
                    path="/company-summary/:id/:name"
                    element={<CompanySummary />}
                  />
                  <Route
                    path="/company-summary/:id"
                    element={<CompanySummary />}
                  />

                  <Route
                    path="/reputation-manager/settings"
                    element={
                      <ReputationManagerContainer>
                        <Settings />
                      </ReputationManagerContainer>
                    }
                  />
                  <Route
                    path="/reputation-manager/reviews"
                    element={
                      <ReputationManagerContainer>
                        <Reviews />
                      </ReputationManagerContainer>
                    }
                  />
                  <Route
                    path="/my-account"
                    element={
                      <>
                        <Meta
                          title={metaInfo.myAccount.title}
                          description={metaInfo.myAccount.description}
                          keywords={metaInfo.myAccount.keywords}
                        />
                        <UserAccountInfo />
                      </>
                    }
                  />
                  <Route
                    path="/settings/user-management"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2L.title}
                          description={metaInfo.settingsW2L.description}
                          keywords={metaInfo.settingsW2L.keywords}
                        />
                        <AdminContainer>
                          <UserManagement />
                        </AdminContainer>
                      </>
                    }
                  />
                  <Route
                    path="/settings/web-to-lead"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2L.title}
                          description={metaInfo.settingsW2L.description}
                          keywords={metaInfo.settingsW2L.keywords}
                        />
                        <AdminContainer>
                          <Web2Lead />
                        </AdminContainer>
                      </>
                    }
                  />
                  <Route
                    path="/settings/web-to-lead/create-form"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2LCreateForm.title}
                          description={
                            metaInfo.settingsW2LCreateForm.description
                          }
                          keywords={metaInfo.settingsW2LCreateForm.keywords}
                        />

                        <AdminContainer>
                          <CreateLeadForm />
                        </AdminContainer>
                      </>
                    }
                  />
                  <Route
                    path="/settings/web-to-lead/:id"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2LCreateForm.title}
                          description={
                            metaInfo.settingsW2LCreateForm.description
                          }
                          keywords={metaInfo.settingsW2LCreateForm.keywords}
                        />
                        <AdminContainer>
                          <CreateLeadForm isEdit />{" "}
                        </AdminContainer>
                      </>
                    }
                  />
                  <Route
                    path="/settings/email-setup"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsEmailSetup.title}
                          description={metaInfo.settingsEmailSetup.description}
                          keywords={metaInfo.settingsEmailSetup.keywords}
                        />
                        <AdminContainer>
                          <EmailSetup />{" "}
                        </AdminContainer>
                      </>
                    }
                  />
                  <Route
                    path="/oauth2/google-authorize"
                    element={<AuthCallback type="gmail" />}
                  />
                  <Route
                    path="/oauth2/azure-authorize"
                    element={<AuthCallback type="outlook" />}
                  />
                  <Route
                    path="/oauth2/azure-signin-authorize"
                    element={<AuthCallback type="signin-outlook" />}
                  />
                  <Route
                    path="/oauth2/azure-signup-authorize"
                    element={<AuthCallback type="signup-outlook" />}
                  />
                  <Route
                    path="/oauth2/google-signin-authorize"
                    element={<AuthCallback type="signin-google" />}
                  />
                  <Route
                    path="/oauth2/google-signup-authorize"
                    element={<AuthCallback type="signup-google" />}
                  />
                  <Route
                    path="/oauth2/google-reputation-manager-authorize"
                    element={<AuthCallback type="reputation-manager-google" />}
                  />
                  <Route
                    path="/our-data"
                    element={
                      <>
                        <Meta
                          title={metaInfo.ourData.title}
                          description={metaInfo.ourData.description}
                          keywords={metaInfo.ourData.keywords}
                        />
                        <OurData />
                      </>
                    }
                  />
                  {/* <Route path="/direct-dials" element={<DirectDials />} /> */}
                  <Route
                    path="/lead-management"
                    element={
                      <>
                        <Meta
                          title={metaInfo.ourData.title}
                          description={metaInfo.ourData.description}
                          keywords={metaInfo.ourData.keywords}
                        />
                        <LeadsManagement />
                      </>
                    }
                  />
                  <Route
                    path="/integrations"
                    element={
                      <>
                        <Meta
                          title={metaInfo.integrations.title}
                          description={metaInfo.integrations.description}
                          keywords={metaInfo.integrations.keywords}
                        />
                        <Integrations />
                      </>
                    }
                  />
                  <Route
                    path="/b2b-data"
                    element={
                      <>
                        <Meta
                          title={metaInfo.b2bData.title}
                          description={metaInfo.b2bData.description}
                          keywords={metaInfo.b2bData.keywords}
                        />
                        <B2BData />
                      </>
                    }
                  />
                  <Route
                    path="/faq"
                    element={
                      <>
                        <Meta
                          title={metaInfo.faq.title}
                          description={metaInfo.faq.description}
                          keywords={metaInfo.faq.keywords}
                        />
                        <Faq />
                      </>
                    }
                  />
                  <Route path="/leads" element={<Leads />} />
                  <Route
                    path="/lead-details/:id"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchLead.title}
                          description={metaInfo.searchLead.description}
                          keywords={metaInfo.searchLead.keywords}
                        />
                        <CheckToken type={"leaddetails"} />
                      </>
                    }
                  />
                  <Route
                    path="/more-menu-content"
                    element={<MoreMenuContent />}
                  />
                  <Route
                    path="/leads-timeline"
                    element={<LeadsTimeline tab="3" />}
                  />
                  <Route
                    path="/account/reset/finish"
                    element={<ResetPassword />}
                  />
                  <Route
                    path="/account/change-password"
                    element={<ChangePassword />}
                  />
                  <Route path="/page/:slug" element={<Seo />} />
                  <Route path="/tools/:demoUrl" element={<Demo />} />
                  <Route path="/what-we-offer" element={<WhatWeOffer />} />

                  <Route
                    path="*"
                    element={
                      <>
                        <center className="text-danger">Route NOT FOUND</center>
                      </>
                    }
                  />
                </Routes>
              </RouteGuard>
            </AlertProvider>
          </EmailProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
};
export default AppRoutes;
